import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 40.74" width="1em" height="1em">
    <defs>
      <style />
    </defs>
    <g id="prefix__Layer_2" data-name="Layer 2">
      <g id="prefix__Layer_1-2" data-name="Layer 1">
        <path fill="fj-icons-primary-color" d="M.5 18.36l20.14 11.62L40.5 18.36H.5z" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          d="M.5 18.36L20.5.5l20 17.86"
        />
        <path
          d="M8.1.5h24.8a1.6 1.6 0 011.6 1.6V34h0-28 0V2.1A1.6 1.6 0 018.1.5z"
          strokeMiterlimit={10}
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
        />
        <path
          d="M20.64 30L.5 18.36V38.6a1.65 1.65 0 001.65 1.64h36.7a1.65 1.65 0 001.65-1.64V18.36z"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
        />
        <g className="prefix__cls-6">
          <g className="prefix__cls-7">
            <g className="prefix__cls-7">
              <path
                d="M25.94 15.1a.72.72 0 00-.51-.22h-6.22a.73.73 0 00-.73.73v1h-1.15v-1a.73.73 0 00-.72-.74h-6.22a.76.76 0 00-.52.21.73.73 0 00-.21.52v2.3a1.57 1.57 0 001.54 1.57h4.57a1.55 1.55 0 001.09-.47 1.51 1.51 0 00.46-1.1v-.39h1.14v.4A1.55 1.55 0 0020 19.44h4.57a1.55 1.55 0 001.55-1.55v-2.27a.72.72 0 00-.21-.52m-9.51 2.77a.63.63 0 01-.19.44.6.6 0 01-.44.18H11.2a.63.63 0 01-.63-.63v-2.1h5.83zm8.81 0a.62.62 0 01-.62.62h-4.57a.59.59 0 01-.44-.18.64.64 0 01-.19-.45v-2.1h5.82z"
                fill="#878788"
              />
              <path
                d="M15.83 8a2.44 2.44 0 00-1.74.73c-.14.13-.46.5-.86 1-.57.68-1.28 1.52-2 2.22a5.57 5.57 0 01-1.7 1.1h4a2.42 2.42 0 001.74-.73l2.44-2.45.08-.08.08-.08L19.6 8z"
                fill="#2bc2a3"
              />
              <path fill="#2e8f44" d="M24.26 10.47h4.78l.6-.61h-4.78l-.6.61z" />
              <path
                d="M23.92 10.81l-.08.08-2.1 2.11v.05h3.77a2.61 2.61 0 00.48-.05h.25a2.47 2.47 0 001-.62l1.53-1.54h-4.83z"
                fill="#2bc2a3"
              />
              <path d="M31.47 8H27.7a2.43 2.43 0 00-1.61.6h4.78z" fill="#84ce91" />
              <path fill="#53ad64" d="M25.77 8.95l-.6.6h4.79l.6-.6h-4.79z" />
              <path
                d="M21.72 8.76A2.38 2.38 0 0020.08 8l-1.93 2 2.33 2.34a2.31 2.31 0 00.88.57l2.23-2.25z"
                fill="#20928e"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const InvitesSeqgeq = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default InvitesSeqgeq;
